import siteNotificationsApi from '@/api/siteNotifications';
import { loadEntity } from '@/helpers/utility';

const state = {
    byId: {},

    levels: {
        info: 'Info',
        warning: 'Warning',
        success: 'Success',
        danger: 'Danger',
    },
};

const getters = {
    activeSiteNotifications: state => Object.values(state.byId).filter(n => n.is_enabled),
};

const actions = {
    async getSiteNotifications() {
        let siteNotifications = await siteNotificationsApi.list();
        loadEntity({ siteNotifications });
    },
    async getActiveSiteNotifications() {
        let siteNotifications = await siteNotificationsApi.listActive();
        loadEntity({ siteNotifications });
    },
    async createSiteNotification(store, siteNotification) {
        siteNotification = await siteNotificationsApi.create(siteNotification);
        loadEntity({ siteNotification });
        return siteNotification;
    },
    async updateSiteNotification(store, siteNotification) {
        siteNotification = await siteNotificationsApi.update(siteNotification);
        loadEntity({ siteNotification });
        return siteNotification;
    },
    async deleteSiteNotification({ commit }, siteNotification) {
        let response = await siteNotificationsApi.deleteNotification(siteNotification);
        commit('DELETE_SITE_NOTIFICATION', { response });
    },
    subscribe({ commit }, { channels }) {
        if (channels.indexOf('siteNotifications') === -1)
            return;

        Echo.leave('siteNotifications');

        Echo.private('siteNotifications')
            .listen('App.SiteNotificationUpdated', (e) => loadEntity({ siteNotification: e.siteNotification }))
            .listen('App.SiteNotificationDeleted', (e) => {
                commit('DELETE_SITE_NOTIFICATION', { response: { id: e.id } });
            });
    },
    unsubscribe(store, { channels }) {
        if (channels.indexOf('siteNotifications') === -1)
            return;

        Echo.leave('siteNotifications');
    },
};

const mutations = {
    LOAD_ENTITIES(state, { siteNotifications }) {
        if (siteNotifications)
            Object.values(siteNotifications).forEach(notification => Vue.set(state.byId, notification.id, notification));
    },
    DELETE_SITE_NOTIFICATION(state, { response }) {
        Vue.delete(state.byId, response.id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
